<template>
<div>
  <b-card>
    <div class="text-right mb-3">
      <router-link class="btn btn-primary" :to="{name:'operatorGroups.create'}"><i class="fa fa-plus"></i> Criar</router-link>
    </div>
    <Grid name="operatorGroupsGrid" :preload="preload" v-bind:url="url" v-bind:columns="columns" :pageable='true' :filterable='true' :sortable='true' v-bind:schemaModelFields="schemaModelFields"></Grid>
  </b-card>
</div>
</template>

<script>
import Grid from '@/components/Grid.vue'
import router from '@/router'
import lists from '@/components/States.js'

export default {
  name: 'OperatorsGrid',
  components: {
    Grid
  },
  data() {
    return {
      schemaModelFields: {
        'created_at': {
          type: 'date'
        },
        'id': {
          type: 'number'
        }
      },
      url: 'operatorGroups',
      preload: [],
      columns: [{
        template: this.getBtnTemplate,
        title: '',
        width: '180px'
      },
      {
        field: 'id',
        title: 'Id',
        width: '80px'
      },
      {
        field: 'name',
        title: 'Nome',
        width: '220px'
      },
      {
        field: 'code',
        title: 'Código',
        width: '120px'
      },
      {
        field: 'created_at',
        title: 'Criado em',
        format: '{0:dd/MM/yyyy HH:mm}',
        type: 'date',
        width: '180px',
        filterable: {
          // ui: "datetimepicker"
          ui: function(element) {
            element.kendoDateTimePicker({
              format: 'dd/MM/yyyy HH:mm'
            })
          }
        }
      }]
    }
  },
  methods: {
    getBtnTemplate: function(item) {
      if (this.$auth.check('operatorGroups.edit')) {
        var route = router.resolve({
          name: 'operatorGroups.edit',
          params: {
            id: item.id
          }
        })
        return '<a href="' + route.href + '" class="btn btn-primary" ><i class="fa fa-pencil"></i> editar</a>'
      }
      return ''
    }
  }
}
</script>
